export default __webpack_public_path__ + "e2e3acb7abbcdad37260ef619b9d00cb.svg";